import type { ChipProps } from '@mui/material/Chip'
import { AdminTransactionFilter, getTransactionStatusBucket } from './utils'

export const getSubscriptionStatusChipColor = (
  status: string
): ChipProps['color'] => {
  const normalized = status.toLowerCase()

  if (normalized.includes('active')) return 'success'
  if (normalized.includes('suspend') || normalized.includes('pending')) {
    return 'warning'
  }
  if (normalized.includes('cancel') || normalized.includes('fail')) {
    return 'error'
  }

  return 'default'
}

export const getPendingCancellationChipColor = (
  status?: string
): ChipProps['color'] => {
  const normalized = String(status ?? '').toLowerCase()

  if (normalized.includes('review')) return 'error'
  if (normalized.includes('move-out')) return 'info'
  return 'warning'
}

export const getTransactionStatusChipColor = (
  status?: string
): ChipProps['color'] => {
  const bucket: Exclude<AdminTransactionFilter, 'all'> =
    getTransactionStatusBucket(status)

  switch (bucket) {
    case 'settled':
      return 'success'
    case 'pending':
      return 'warning'
    case 'failed':
      return 'error'
    default:
      return 'default'
  }
}
